<template>
  <div id="tuka">
    <div>
      <section id="content-container" class="container-fluid">
        <div>
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import ComponentGalleryHeader from "./components/ComponentGalleryHeader.vue";
import { mapActions } from "vuex";

export default {
  components: {
    ComponentGalleryHeader: ComponentGalleryHeader,
  },
  methods: {
    ...mapActions(["initPortletId", "initContainerId"]),
  },
  created() {
    this.initPortletId(this.$root.portletId);
    this.initContainerId(this.$root.containerId);
  },
};
</script>

<style>

</style>